import { Loader2 } from 'lucide-react';
import { cn } from '../lib/utils';

interface SpinnerProps {
  className?: string;
  /** Announced to screen readers; pass null beside a visible loading label. */
  label?: string | null;
}

const Spinner = ({ className, label = 'Loading' }: SpinnerProps) => (
  <>
    <Loader2
      aria-hidden
      className={cn('size-5 animate-spin text-brand motion-reduce:animate-none', className)}
    />
    {label ? <span className="sr-only">{label}</span> : null}
  </>
);

export { Spinner };
